import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { globalColor } from 'views/ConstantColors';

// styles
const LoaderWrapper = styled('div')({
    position: 'fixed',
    top: 0,
    left: 0,
    zIndex: 1301,
    width: '100%'
});

// ==============================|| LOADER ||============================== //

const Loader = () => (
    <LoaderWrapper>
        <LinearProgress
            sx={{
                backgroundColor: globalColor,
                '& .MuiLinearProgress-bar': {
                    backgroundColor: globalColor
                }
            }}
        />
    </LoaderWrapper>
);

export default Loader;
